/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Card, Grid, Typography } from '@mui/material';
import { shadowColor } from 'theme/color';
// import SmartButtonOutlinedIcon from "@mui/icons-material/SmartButtonOutlined";
// import GrassIcon from "@mui/icons-material/GrassOutlined";
// import PoolIcon from "@mui/icons-material/PoolOutlined";
// import OutdoorGrillIcon from "@mui/icons-material/OutdoorGrillOutlined";
// import MicrowaveIcon from "@mui/icons-material/MicrowaveOutlined";
// import TvIcon from "@mui/icons-material/TvOutlined";
// import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryServiceOutlined";
// import ShowerIcon from "@mui/icons-material/ShowerOutlined";
// import FitnessCenterIcon from "@mui/icons-material/FitnessCenterOutlined";
// import KitchenOutlinedIcon from "@mui/icons-material/KitchenOutlined";
// import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
// import DryCleaningOutlinedIcon from "@mui/icons-material/DryCleaningOutlined";
// import BabyChangingStationOutlinedIcon from "@mui/icons-material/BabyChangingStationOutlined";
// import BalconyOutlinedIcon from "@mui/icons-material/BalconyOutlined";
import ac from 'assets/svg/ac.svg';
import lawn from 'assets/svg/lawn.svg';
import swiming from 'assets/svg/swiming.svg';
import barbeque from 'assets/svg/barbeque.svg';
import microwave from 'assets/svg/microwave.svg';
import tv from 'assets/svg/tv.svg';
import dryer from 'assets/svg/dryer.svg';
import outShower from 'assets/svg/outShower.svg';
import washer from 'assets/svg/washer.svg';
import gym from 'assets/svg/gym.svg';
import refridge from 'assets/svg/refridge.svg';
import wifi from 'assets/svg/wifi.svg';
import laundry from 'assets/svg/laundry.svg';
import sauna from 'assets/svg/sauna.svg';
import windowCover from 'assets/svg/windowCover.svg';

import {
  fontsize16,
  fontsize24,
  poppins400,
  poppins500,
} from 'theme/common.style';
import { featureContent, featureIcon } from './PropertyProfile.style';

function PropertyFeature(props) {
  return (
    <Card
      variant="outlined"
      style={{
        borderRadius: '8px',
        boxShadow: `0px 1px 8px ${shadowColor}`,
        padding: '30px 20px',
        marginTop: '14px',
      }}
    >
      <Grid>
        <Grid sx={{ ...poppins500, ...fontsize24 }}>Features</Grid>
        <Grid sx={{ marginTop: '20px' }}>
          <Grid sx={{ display: 'flex', justifyContent: 'space-around' }}>
            <Typography sx={featureContent}>
              <img alt="ac" src={ac} style={featureIcon} />
              Air Conditioning
            </Typography>
            <Typography sx={featureContent}>
              <img alt="lawn" src={lawn} style={featureIcon} />
              Lawn
            </Typography>
            <Typography sx={featureContent}>
              <img alt="swimming" src={swiming} style={featureIcon} />
              Swimming Pool
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'space-around',
              marginTop: '15px',
            }}
          >
            <Typography sx={featureContent}>
              <img alt="brbequ" src={barbeque} style={featureIcon} />
              Barbeque
            </Typography>
            <Typography sx={featureContent}>
              <img alt="microwave" src={microwave} style={featureIcon} />
              Micriwave
            </Typography>
            <Typography sx={featureContent}>
              <img alt="tv" src={tv} style={featureIcon} />
              TV Cable
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'space-around',
              marginTop: '15px',
            }}
          >
            <Typography sx={featureContent}>
              <img alt="dryer" src={dryer} style={featureIcon} />
              Dryer
            </Typography>
            <Typography sx={featureContent}>
              <img alt="outdoor Shower" src={outShower} style={featureIcon} />
              Outdoor Shower
            </Typography>
            <Typography sx={featureContent}>
              <img alt="washer" src={washer} style={featureIcon} />
              Washer
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'space-around',
              marginTop: '15px',
            }}
          >
            <Typography sx={featureContent}>
              <img alt="gym" src={gym} style={featureIcon} />
              Gym
            </Typography>
            <Typography sx={featureContent}>
              <img alt="refrige" src={refridge} style={featureIcon} />
              Refrigerator
            </Typography>
            <Typography sx={featureContent}>
              <img alt="wifi" src={wifi} style={featureIcon} />
              Wifi
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'space-around',
              marginTop: '15px',
            }}
          >
            <Typography sx={featureContent}>
              <img alt="laundry" src={laundry} style={featureIcon} />
              Laundry
            </Typography>
            <Typography sx={featureContent}>
              <img alt="sauna" src={sauna} style={featureIcon} />
              sauna
            </Typography>
            <Typography sx={featureContent}>
              <img alt="windowCover" src={windowCover} style={featureIcon} />
              Window covering
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

PropertyFeature.propTypes = {};

export default PropertyFeature;
